export default "__VITE_ASSET__CrpV7rcd__"